import {wifiSvg as Icon__small__wifiSvg} from '../Icon__small/Icon__small--wifi.js'

export var wifi = {
  name: 'wifi',
  category: 'icon',
  colorable: true,
  svg: Icon__small__wifiSvg,
};
